import script from "./student_PLO.vue?vue&type=script&setup=true&lang=js"
export * from "./student_PLO.vue?vue&type=script&setup=true&lang=js"

import "./student_PLO.vue?vue&type=style&index=0&id=badc9ec4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-badc9ec4"]])

export default __exports__